<template>
  <div>
    <v-card>
      <v-card-title>Remaining Leave Balance</v-card-title>
      <v-row class="px-4">
        <v-col>
          <v-autocomplete
            v-model="state"
            v-validate="'required'"
            :loading="dropdownLoading"
            label="States"
            :items="states"
            :error-messages="errors.collect('state')"
            data-vv-name="state"  
            data-vv-as="states"
            chips
            deletable-chips
            hide-selected
            multiple
            item-text="name"
            item-value="id"
            small-chips
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="department"
            v-validate="'required'"
            :loading="dropdownLoading"
            label="Departments"
            :items="departments"
            :error-messages="errors.collect('department')"
            data-vv-name="department"  
            data-vv-as="departments"
            chips
            deletable-chips
            hide-selected
            multiple
            item-text="name"
            item-value="id"
            small-chips
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="leaveType"
            v-validate="'required'"
            :loading="dropdownLoading"
            label="Leave Type"
            :items="leaveTypes"
            :error-messages="errors.collect('leaveType')"
            data-vv-name="leaveType"  
            data-vv-as="leave type"
            chips
            deletable-chips
            hide-selected
            multiple
            item-text="name"
            item-value="id"
            small-chips
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="year"
            v-validate="'required'"
            :loading="dropdownLoading"
            :items="years"
            label="Year"
            :error-messages="errors.collect('year')"
            data-vv-name="year"  
            data-vv-as="year"
            chips
            hide-selected
            small-chips
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="month"
            v-validate="'required'"
            :loading="dropdownLoading"
            :error-messages="errors.collect('month')"
            data-vv-name="month"  
            data-vv-as="month"
            :items="months"
            label="Up To"   
            chips
            hide-selected
            small-chips
            item-text="name"
            item-value="id"
          />
        </v-col>
  
        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-row>
            <v-btn
              class="mx-3"
              :loading="loading"
              color="primary"
              @click="generateRemainingLeaveBalance"
            >
              generate
            </v-btn>
          </v-row> 
        </v-col>
      </v-row>
    </v-card> 
  </div>
</template>

<script>
  // import { mapState } from 'vuex'
  // import Csv from 'vue-json-csv'
  
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    // inject: ['$validator'],
    // components: {
    //   Csv,
    // },

    data () {
      return {
        dropdownLoading: false,
        loading: false,
        state: null,
        states: [],
        department: null,
        departments: [],
        year: null,
        years: [], 
        leaveTypes: [],
        leaveType: null,
        month: null,
        months: [
          { id: 1, name: 'January' },
          { id: 2, name: 'February' }, 
          { id: 3, name: 'March' }, 
          { id: 4, name: 'April' },
          { id: 5, name: 'May' }, 
          { id: 6, name: 'June' }, 
          { id: 7, name: 'July' },
          { id: 8, name: 'August' },
          { id: 9, name: 'September' },
          { id: 10, name: 'October' },
          { id: 11, name: 'November' },
          { id: 12, name: 'December' },
        ],
        // dataForExcel: [],
      }
    },

    computed: {
      // ...mapState({ employee: 'currentEmployee' }),
      // reportName () {
      //   if (!this.leaveType) return
        
      //   let type = this.leaveTypes.find(leaveType => leaveType.id === this.leaveType).name 
      //   let name = []
      //   this.departments.map(department => {
      //     if (this.selectedDepartments.includes(department.id)) {
      //       name.push(department.name)
      //     }
      //   })  

      //   return type + '(' + name.toString() + ')' + '.csv'  
      // },
    },

    created () {
      this.dropdownLoading = true
      
      Promise.all([
        this.$api.departments().list(),
        this.$api.leaveTypes().list(),
        this.$api.states().list(),
        this.$api.leaveEntitlements().listEntitlementYear(),
      ])
        .then(([departments, leaveTypes, states, leaveEntitlements]) => {
          this.departments = departments.data        
          this.leaveTypes = leaveTypes.data        
          this.states = states.data
          this.years = leaveEntitlements.data

          this.dropdownLoading = false
        })
    },

    methods: {
      generateRemainingLeaveBalance () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.loading = true

            this.$api.leaveReports().generateRemainingLeaveBalance(this.prepareFormData())
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'Remaining Leave Balance Reports-' + this.year + '.xlsx')
                link.click()
                this.loading = false

                this.$snack({ message: 'Report downloaded successfully' })
              }).catch(() => {
                this.loading = false
                this.$snack({ color: 'error', message: 'Error! Please contact support' })
              })
          })
      },

      prepareFormData () {
        return {
          states: this.state,
          departments: this.department,
          leaveTypes: this.leaveType,
          year: this.year,
          endDate: this.$moment(this.$moment([this.year, this.month - 1])).endOf('month').format('YYYY-MM-DD'),

        }
      },

    },
  }
</script>
